<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  data() {
    return {
      tab_type: 1,
      newsdata: [
        {
          id: 1,
          title: "标题测试",
          desc: "小正文测试",
          date: "2025-04-30",
        },
        {
          id: 2,
          title: "标题测试",
          desc: "小正文测试",
          date: "2025-04-30",
        },
        {
          id: 3,
          title: "标题测试",
          desc: "小正文测试",
          date: "2025-04-30",
        },
        {
          id: 4,
          title: "标题测试",
          desc: "小正文测试",
          date: "2025-04-30",
        },
        {
          id: 5,
          title: "标题测试5",
          desc: "小正文测试",
          date: "2025-04-30",
        }
      ],
      newswiper: null,
    };
  },
  mounted() {
    this.newswiper = new Swiper(".swiper-container", {
      slidesPerView: 4,
      height: 300,
    });
  },
  methods: {
    toleft: function () {
      this.newswiper.slidePrev();
    },
    toright: function () {
      this.newswiper.slideNext();
    },
    changeTab: function (type) {
      this.tab_type = type;
      if (type == "1") {
        this.newsdata = [
          {
            id: 1,
            title: "公司-标题测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },
          {
            id: 2,
            title: "公司-标题测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },
          {
            id: 3,
            title: "公司-标题测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },
          {
            id: 4,
            title: "公司-标题测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },     
          {
          id: 5,
          title: "标题测试5",
          desc: "小正文测试",
          date: "2025-04-30",
        },
        ];
      } else {
        this.newsdata = [
          {
            id: 1,
            title: "行业-标题测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },
          {
            id: 2,
            title: "行业-测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },
          {
            id: 3,
            title: "行业-测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },
          {
            id: 4,
            title: "行业-测试",
            desc: "小正文测试",
            date: "2025-04-30",
          },
          {
          id: 5,
          title: "标题测试5",
          desc: "小正文测试",
          date: "2025-04-30",
        }
        ];
      }
      if (this.newswiper) {
        this.newswiper = null;
      }
      this.newswiper = new Swiper(".swiper-container", {
        slidesPerView: 4,
        height: 300,
      });
    },
    itemmoseover(event) {
      if (event.target.querySelector(".news_item_btn img")) {
        // console.log("event==", event.target.querySelector(".news_item_btn img"));
        event.target.querySelector(".news_item_btn img").src = require("../../assets/int.png");
      }
    },
    itemmouseout(event) {
      if (event.target.querySelector(".news_item_btn img")) {
        // console.log("event==", event.target.querySelector(".news_item_btn img"));
        event.target.querySelector(".news_item_btn img").src = require("../../assets/int.png");
      }
    },
    openPage(id) {
      this.$router.push("/DetailPage?id=" + id);
    },
  },
};
</script>
<template>
  <div class="detail_banner">
    <div class="news_banner_item">
      <img src="../../assets/new1.jpg" />
    </div>
  </div>
  <div class="contaier content">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>新闻</span>
            <span class="red">资讯</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
        <div class="title2">News</div>
      </div>
      <div class="news">
        <div class="news_tabs flex">
          <div class="flex-item"></div>
          <div
            @click="changeTab('1')"
            class="news_tab_item"
            :class="{ news_tab_item_active: tab_type == '1' }"
          >
            行业新闻
          </div>
          <div
            @click="changeTab('2')"
            class="news_tab_item"
            :class="{ news_tab_item_active: tab_type != '1' }"
          >
            公司新闻
          </div>
          <div class="flex-item"></div>
        </div>
        <div style="margin-top: 20px; position: relative">
          <div class="left_btn" >
            <div class="left_btn_item" @click="toleft">
              <img src="../../assets/left.png" />
            </div>
          </div>
          <div class="swiper-container">
            <div class="items swiper-wrapper">
              <div
                class="swiper-slide news_item"
                @click="openPage(item.id)"
                v-for="item in newsdata"
                :key="item.id"
                @mouseover="itemmoseover"
                @mouseout="itemmouseout"
              >
                <div class="date">
                  {{ item.date.split("-")[1] + "-" + item.date.split("-")[2] }}
                </div>
                <div
                  style="
                    height: 2px;
                    background: #f8f8f8;

                    width: 100px;
                  "
                ></div>
                <div class="year">{{ item.date.split("-")[0] }}</div>
                <div class="news_title">{{ item.title }}</div>
                <div class="news_desc">{{ item.desc }}</div>
                <div class="news_item_btn"><img src="../../assets/int.png" /></div>
              </div>
            </div>
          </div>
          <div class="right_btn">
            <div class="right_btn_item" @click="toright">
              <img src="../../assets/right.png" />
            </div>
          </div>
        </div>
      </div>
    </div>``
  </div>
</template>

<style>
.news .swiper-container {
  width: 100%;
  height: 400px;
}
.news_tabs {
  margin-top: 20px;
}
.news_tab_item {
  width: 180px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  background: #f8f8f8;
  cursor: pointer;
}
.news_tab_item:hover {
  background: #dc5300;
  color: #fff;
}
.news_tab_item_active {
  background: #dc5300;
  color: #fff;
}
.news .left_btn_item {
  position: absolute;
  top: 130px;
  left: -60px;
  width: 40px;
  height: 40px;
  text-align: center;
  background: #ccc;
  cursor: pointer;
}
.news .left_btn_item img {
  width: 40px;
}
.news .left_btn_item:hover {
  background: #dc5300;
}
.news .right_btn_item {
  position: absolute;
  top: 130px;
  right: -60px;
  width: 40px;
  height: 40px;
  text-align: center;
  background: #ccc;
  cursor: pointer;
}
.news .right_btn_item img {
  width: 40px;
}
.news .right_btn_item:hover {
  background: #dc5300;
}
.news .items {
  margin-top: 30px;
  margin-bottom: 50px;
}
.news .news_item {
  height: 300px;
  /* width: 25%; */
  padding: 10px;
  cursor: pointer;
}
.news .news_item .date {
  font-size: 18px;
  color: #000;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
}
.news .news_item .year {
  font-size: 16px;
  color: #999;
  height: 30px;
  line-height: 30px;
}
.news .news_item .news_title {
  font-size: 18px;
  color: #000;
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news .news_item .news_desc {
  font-size: 14px;
  color: #666;
  line-height: 30px;
  height: 90px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: 3; */
  overflow: hidden;
}
.news .news_item .news_item_btn {
  width: 40px;
  height: 40px;
  text-align: center;
  background: #ccc;
  margin-top: 30px;
}
.news .news_item .news_item_btn img {
  width: 10px;
  height: 40px;
}
.news .news_item:hover {
  background: #f8f8f8;
}
.news .news_item:hover .news_item_btn {
  background: #dc5300;
}
</style>
